import { render, staticRenderFns } from "./TyaReadiness.vue?vue&type=template&id=129687c0&scoped=true"
import script from "./TyaReadiness.vue?vue&type=script&lang=js"
export * from "./TyaReadiness.vue?vue&type=script&lang=js"
import style0 from "./TyaReadiness.vue?vue&type=style&index=0&id=129687c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129687c0",
  null
  
)

export default component.exports